import React from 'react'
import { ReactComponent as Checkbox } from '../../../../assets/svg/CheckedCheckbox.svg'
import { ReactComponent as GreenCheckbox } from '../../../../assets/svg/CheckedCheckboxGreen.svg'

const CheckedCheckbox = ({ checked, text, onClick, icon, subText, disabled = false }) => {
    return (
        <div className={`px-[8px]  ${icon ? 'w-[308px]' : ''} ${disabled ? 'cursor-default' : 'cursor-pointer'}`} onClick={onClick}>
            <div className="flex flex-row items-center gap-[8px] ">
                <div className="h-[18px] w-[32px] flex items-center justify-center">{!checked ? <Checkbox /> : <GreenCheckbox />}</div>
                <div className="flex flex-row items-center justify-center gap-[6px]">
                    <p className="font-bold text-[14px] leading-5 text-darkenPurple">{text}</p>
                    <div className="h-[20px] w-[20px]">{icon && <img src={icon} alt="icon" />}</div>
                </div>
            </div>
            <div className="ml-[40px] mt-[2px] w-full ">{subText && <p className="text-darkenPurple font-medium text-[14px] leading-5">{subText}</p>}</div>
        </div>
    )
}

export default CheckedCheckbox
